import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal, QRCode } from 'antd';
import { toast } from 'react-toastify';
import { CopyOutlined } from '@ant-design/icons';
import { Button, Input, Typography } from '@atoms';

import { 
  RepostContentWrapper,
  RepostCopyButton,
  RepostCopyInputWrapper,
  RepostCopyLine,
  RepostCopyTitleWrapper,
  RepostParent
} from './repost.styles';
import { IRepost } from './repost.types';
import { Shared } from '@molecules';
import RepostIcon from "@assets/icons/repost.svg";
import QRIcon from "@assets/icons/qr.svg";
import { useState } from 'react';
import { useIsMobile } from 'hooks';

const RepostContent = ({ name }: { name: string }) => {
  const { t } = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href.replace('/my-stories/', '/stories/'));
    toast.success(t("linkСopied"), { autoClose: 2000 });
  };

  return (
    <RepostContentWrapper>
      <Typography
        style={{ textAlign: "center", marginBottom: "30px" }}
      >
        {t("repost")}
      </Typography>
      <QRCode
        style={{
          margin: "auto",
          border: "none",
          background: "#fff",
        }}
        value={window.location.href.replace('/my-stories/', '/stories/')}
      />
      <Typography
        as="h2"
        style={{
          margin: "10px auto 30px auto",
          width: "max-content",
        }}
      >
        {name}
      </Typography>

      <RepostCopyTitleWrapper>
        <RepostCopyLine />
        <Typography style={{ color: "rgba(166, 158, 149, 1)" }}>
          {t("copyLink")}
        </Typography>
        <RepostCopyLine />
      </RepostCopyTitleWrapper>
      <RepostCopyInputWrapper>
        <Input value={window.location.href.replace('/my-stories/', '/stories/')} />
        <RepostCopyButton onClick={handleCopy}>
          <CopyOutlined />
        </RepostCopyButton>
      </RepostCopyInputWrapper>
    </RepostContentWrapper>
  )
}

function Repost({ name, isCandle }: IRepost) {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab");
  const isMobile = useIsMobile(767);

  const [sharedOpen, setSharedOpen] = useState(false)
  const [repostOpen, setRepostOpen] = useState(false)

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: t("checkStory"),
          text: name,
          url: window.location.href.replace('/my-stories/', '/stories/'),
        });
      } catch (error) {
        console.error("Ошибка при попытке поделиться:", error);
      }
    } else {
      console.log("Web Share API не поддерживается в этом браузере.");
    }
  };

  return (
    tab === null || tab === "repost" || isCandle ? (
      <RepostParent isCandle={isCandle}>
        {(!isMobile || isCandle) && (
          <>
            <Typography onClick={() => isMobile ? handleShare() : setSharedOpen(true)} as="h4">
              <img src={RepostIcon} alt="repost" />
              {t("share")}
            </Typography>
            <Typography onClick={() => setRepostOpen(true)} as="h4">
              <img src={QRIcon} alt="repost" />
              {t("createQR")}
            </Typography>
          </>
        )}

        <Shared
          isVisible={sharedOpen}
          onClose={() => setSharedOpen(false)}
          storyLink={window.location.href.replace('/my-stories/', '/stories/')}
        />

        {!isMobile || isCandle ? (
          <Modal
            forceRender
            open={repostOpen}
            onCancel={() => setRepostOpen(false)}
            closeIcon={null}
            width={549}
            styles={{
              content: {
                background: "rgba(249, 242, 236, 1)",
              },
            }}
            footer={[
              <Button
                variant="outlined"
                key="cancel"
                onClick={() => setRepostOpen(false)}
              >
                {t("close")}
              </Button>,
            ]}
          >
            <RepostContent name={name} />
          </Modal>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <RepostContent name={name} />
            <Typography
              style={{
                justifyContent: "center",
                padding: "17px 0",
                background: "#f9f2ec",
                border: "1px solid #e4d7cd",
                borderRadius: "8px"
              }}
              onClick={handleShare}
              as="h4"
            >
              <img src={RepostIcon} alt="repost" />
              {t("share")}
            </Typography>
          </div>
        )}
      </RepostParent>
    ) : null
  )
}

export default Repost